import { FinalNode } from 'utils/adl-services';

export const END_OF_SURVEY = '0';
export const END_OF_SURVEY_LABEL = 'end';

export const endOfSurveyNode = {
  id: FinalNode,
  label: END_OF_SURVEY_LABEL,
};

export const CLASSES = {
  DISPLAY_LOGIC_ACTION: 'display-logic-action',
  HIDDEN_LOGIC_ACTION: 'hidden-logic-action',
};
